var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import styled from '@emotion/styled';
import { Grid, GridItem } from '../../common/components/Grid';
import { ThemedMedia } from '../../common/components/Media';
import { useAccordion } from '../../common/hooks/accordion';
import Separator from '../../common/components/Separator';
import LinkSectionGroup from './LinkSectionGroup';
import { SectionName } from './enums';
var FooterGridWrapper = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var FooterGrid = function (props) {
    var __legacy_shop_reboot_max_width = props.__legacy_shop_reboot_max_width, isCollapsible = props.isCollapsible, general = props.general, help = props.help, payment = props.payment, international = props.international, shipping = props.shipping, social = props.social;
    var generalOnly = [help, payment, international, shipping, social].every(function (section) { return !section; });
    var _a = __read(useAccordion(!generalOnly && isCollapsible, [
        'general',
    ]), 2), toggle = _a[0], isExpanded = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, { display: ['none', null, 'block'] }),
        React.createElement(FooterGridWrapper, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width, pt: !generalOnly && [null, null, 'sp_12', 'sp_16'] },
            React.createElement(GridItem, { w: generalOnly ? 1 : [1, null, 6 / 12] },
                React.createElement(LinkSectionGroup, __assign({}, general, { sectionName: SectionName.General, isExpanded: isExpanded, isCollapsible: isCollapsible, isInline: generalOnly, onTitleClick: toggle }))),
            help && (React.createElement(GridItem, { w: [1, null, 6 / 12] },
                React.createElement(LinkSectionGroup, __assign({}, help, { sectionName: SectionName.Help, isExpanded: isExpanded, isCollapsible: isCollapsible, onTitleClick: toggle })))),
            payment && (React.createElement(GridItem, { w: [1, null, 3 / 12] },
                React.createElement(LinkSectionGroup, __assign({}, payment, { sectionName: SectionName.Payment, isExpanded: isExpanded, isCollapsible: isCollapsible, onTitleClick: toggle })))),
            shipping && (React.createElement(GridItem, { w: [1, null, 3 / 12] },
                React.createElement(LinkSectionGroup, __assign({}, shipping, { sectionName: SectionName.Shipping, isExpanded: isExpanded, isCollapsible: isCollapsible, onTitleClick: toggle })))),
            international && (React.createElement(GridItem, { w: [1, null, 3 / 12] },
                React.createElement(LinkSectionGroup, __assign({}, international, { sectionName: SectionName.International, isExpanded: isExpanded, isCollapsible: isCollapsible, onTitleClick: toggle })))),
            social && (React.createElement(GridItem, { w: [1, null, 3 / 12] },
                React.createElement(LinkSectionGroup, __assign({}, social, { sectionName: SectionName.Social, isExpanded: isExpanded, isCollapsible: isCollapsible, onTitleClick: toggle })))))));
};
var FooterLinkSection = function (props) { return (React.createElement(ThemedMedia, null, function (_a) {
    var desktop = _a.desktop;
    return React.createElement(FooterGrid, __assign({ isCollapsible: !desktop }, props));
})); };
FooterLinkSection.defaultProps = {
    __legacy_shop_reboot_max_width: true,
};
export default FooterLinkSection;
var templateObject_1;
